import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { setReportVersionDeprecated } from '../api/make-api'
import apiStateReducer from './ApiStateStore'
import appReducer, { appActions } from './AppStore/app-store'
import autoRslaWorksheetReducer from './AutoRslaWorksheet/auto-rsla-worksheet-store'
import worksheetReducer from './AutoWorksheet/auto-worksheet-store'
import availableCreditReducer from './AvailableCredit/available-credit-store'
import b2cWorksheetReducer from './B2cWorksheet/b2c-worksheet-store'
import creditReducer from './CreditApplication/credit-application-store'
import creditDashBoardEntryReducer from './CreditDashboardEntry/credit-dashboard-entry-store'
import creditRslaWorksheetReducer from './CreditRslaWorksheet/credit-rsla-worksheet-store'
import creditTaskDashBoardEntryReducer from './CreditTaskDashboardEntry/credit-task-dashboard-entry-store'
import documentReducer from './Document/document-store'
import electronicSignatureReducer from './ElectronicSignature/electronic-signature-store'
import mechanicalWarrantyWorksheetReducer from './MechanicalWarrantyWorksheet/mechanical-warranty-worksheet-store'
import ifXpressWorksheetReducer from './IfXpressWorksheet/ifxpress-worksheet-store'
import messageReducer from './Message/message-store'
import personalLoanWorksheetReducer from './PersonalLoanWorksheet/personal-loan-worksheet-store'
import productsWorksheetReducer from './ProductsWorksheet/products-worksheet-store'
import reportReducer from './report/report-store'
import requiredExternalStepReducer from './RequiredExternalStep/required-external-step-store'
import userReducer from './UserStore/user-store'
import vehicleReducer from './Vehicle/vehicle-store'

function InitializeStore() {
  const str = configureStore({
    reducer: {
      app: appReducer,
      user: userReducer,
      credit: creditReducer,
      creditTaskDashBoardEntry: creditTaskDashBoardEntryReducer,
      creditDashBoardEntry: creditDashBoardEntryReducer,
      api: apiStateReducer,
      worksheet: worksheetReducer,
      vehicle: vehicleReducer,
      document: documentReducer,
      message: messageReducer,
      requiredExternalStep: requiredExternalStepReducer,
      personalLoanWorksheet: personalLoanWorksheetReducer,
      ifXpressWorksheet: ifXpressWorksheetReducer,
      b2cWorksheet: b2cWorksheetReducer,
      electronicSignature: electronicSignatureReducer,
      report: reportReducer,
      availableCredit: availableCreditReducer,
      autoRslaWorksheet: autoRslaWorksheetReducer,
      creditRslaWorksheet: creditRslaWorksheetReducer,
      productsWorksheet: productsWorksheetReducer,
      mechanicalWarrantyWorksheet: mechanicalWarrantyWorksheetReducer,
    },
  })
  setReportVersionDeprecated(() => str.dispatch(appActions.setDeprecated(true)))
  return str
}

export const store = InitializeStore()

export type TRootState = ReturnType<typeof store.getState>
export type TAppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<TAppDispatch>()
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector
